var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    {},
    [
      _c("div", { staticClass: "ly_footer" }, [
        _c("div", { staticClass: "ly_footer_inner" }, [
          _c("div", { staticClass: "footer" }, [
            _c("p", { staticClass: "footer_imgWrap" }, [
              _c("img", {
                staticClass: "footer_img",
                attrs: {
                  src: _vm.dir + "/src/assets/img/yusuugaku-logo-gold.svg",
                  alt: "yusuugaku 由数学",
                },
              }),
            ]),
            _vm._v(" "),
            _c("nav", { staticClass: "footerNav mt-40 mt-md-60 mt-lg-80" }, [
              _c("ul", { staticClass: "footerNav_list ff_serif" }, [
                _c(
                  "li",
                  { staticClass: "footerNav_item" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "footerNav_link link-light",
                        attrs: { to: "/" },
                      },
                      [_vm._v("Home")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "footerNav_item" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "footerNav_link link-light",
                        attrs: { to: "/greeting" },
                      },
                      [_vm._v("ご挨拶")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "footerNav_item" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "footerNav_link link-light",
                        attrs: { to: "/branch-introduction" },
                      },
                      [_vm._v("各支部校")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "footerNav_item" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "footerNav_link link-light",
                        attrs: { to: "/contact" },
                      },
                      [_vm._v("お問い合わせ")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "footerNav_item" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "footerNav_link link-light",
                        attrs: { to: "/sign-in" },
                      },
                      [_vm._v("SignIn")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "mt-50 mt-lg-80 d-flex justify_content_center" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "el_btnA",
                      attrs: { to: "/entry-pre-seminar" },
                    },
                    [_vm._v("ENTRY")]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm._m(0),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("PageTopBtn"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "mt-50 text-white-50" }, [
      _c("small", [_vm._v("© 2022 由数学協会")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }